export default __webpack_public_path__ + "static/media/white-flowers-l.5cdbb4e6.svg";